<template>
  <loadable :loading="item === null" :description="$t('profile.loading')">
    <v-container fluid v-if="item !== null">
      <v-layout row wrap>
        <v-flex xs6>
          <profile-common v-model="item" />
        </v-flex>

        <v-flex xs6>
          <profile-password v-model="item" />
        </v-flex>
      </v-layout>

      <v-layout row wrap class="mt-3">
        <v-flex xs6>
          <profile-certificates v-model="item" />
        </v-flex>

        <v-flex xs6>
          <profile-accesses v-model="item" />
        </v-flex>
      </v-layout>
    </v-container>
  </loadable>
</template>

<script>
import User from '@/models/User'
import ProfileCommon from '@/components/Profile/Common'
import ProfilePassword from '@/components/Profile/Password'
import ProfileCertificates from '@/components/Profile/Certificates'
import ProfileAccesses from '@/components/Profile/Accesses'

export default {
  data () {
    return {
      item: null
    }
  },
  created () {
    User
      .getSelf(this.$store.auth.user.username)
      .then(item => {
        this.item = item
      })
  },
  components: {
    ProfileCommon,
    ProfilePassword,
    ProfileCertificates,
    ProfileAccesses
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Profile.vue?0b09e054